import ContactSection from "../../components/marketing/ContactSection";

const ContactPage = () => {
  return (
    <div className="assist">
      <ContactSection />
    </div>
  );
};

export default ContactPage;